// extracted by mini-css-extract-plugin
export var label = "SearchFormLinksField-module--label--B8aM2";